<h2 mat-dialog-title>
   XLSX fájl feltöltés
   <button mat-icon-button (click)="close()" style="float: right">
      <mat-icon>close</mat-icon>
   </button>
</h2>

<div mat-dialog-content>
   <div *ngIf="!selectedFile">
      <input type="file" accept=".xlsx" (change)="onFileSelected($event)" />
   </div>

   <div *ngIf="selectedFile">
      <p><strong>Kiválasztott fájl:</strong> {{ selectedFile.name }}</p>
   </div>
</div>

<div mat-dialog-actions align="end">
   <ng-container *ngIf="selectedFile; else noFile">
      <button mat-button (click)="reset()">Másik fájl</button>
      <button mat-flat-button color="primary" (click)="upload()">Feltöltés</button>
   </ng-container>

   <ng-template #noFile>
      <button mat-button (click)="close()">Mégse</button>
   </ng-template>
</div>
